export default "__VITE_ASSET__Bx7b1IGN__"